export default (props, vars) => {
  const applicationOffer = vars?.useapplicationoffer2?.applicationOffer;
  if (!applicationOffer) return '';

  const { start_date } = applicationOffer;
  return start_date ? `Start Date: ${start_date}` : '';
};
